import(/* webpackMode: "eager" */ "/app/src/app/layouts/squeezed/squeezeColumns.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/squeezed/squeezePage.tsx");
